export const viewTypes = {
    none:                   'None',
    testIntro:              'TestIntro',
    mainCategoryIntro:      'MainCategoryIntro',
    subCategoryIntro:       'SubCategoryIntro',
    blockIntro:             'BlockIntro',
    questionPresenter:      'QuestionPresenter',
    selfRatingView:         'SelfRatingView',
    performanceSummaryView: 'PerformanceSummaryView',
    resultsView:            'ResultsView',
}

export default viewTypes